import { useState, useEffect } from 'react';
import selectFallbackCat from '@/libs/FallbackImageSelect/FallbackImageSelect';

// Define the type for fallback images
interface FallbackImagesProps {
  name: string;
  path: string;
  files: any[];
}
const useResFallbackImages = () => {
  const [resFallbackImages, setResFallbackImages] = useState<FallbackImagesProps[]>([]);
  useEffect(() => {
    const fetchFallbackImages = async () => {
      try {
        const response = await fetch('/hub/fallBackImage.json');
        const data = await response.json();
        setResFallbackImages(data);
      } catch (error) {
        console.error('Error fetching fallback images:', error);
      }
    };
    fetchFallbackImages();
  }, []);
  return resFallbackImages;
};
export default useResFallbackImages;